module.exports = __webpack_public_path__ + "static/media/hereditary.cbe0e49b.png";